export const appRoutes = Object.freeze({
  static: {
    root: '/app',
  },
});
